import { TextField, Box, Typography } from "@mui/material";
import MoedaInput from "../../../../util/ui/inputs/moedaInput";

type Props = {
  setPropriedadeNota: (nome: string, valor: any) => void;
  corretagem?: number;
  iss?: number;
  irrf?: number;
  outrosCustos?: number;
  totalCorretagem?: number;
  readOnly: boolean;
};

export default function CustosCorretagem({
  setPropriedadeNota,
  corretagem,
  iss,
  irrf,
  outrosCustos,
  totalCorretagem,
  readOnly,
}: Props) {
  return (
    <Box
      display={"flex"}
      flexDirection="column"
      width="100%"
      paddingX={1}
      paddingY={2}
    >
      {/* Section header do sistema: eyebrow mono tracked sobre hairline. */}
      <Box
        borderBottom={1}
        borderColor="divider"
        paddingBottom={1}
        marginBottom={1.5}
      >
        <Typography variant="eyebrow" color="text.secondary">
          Corretagem e despesas
        </Typography>
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Corretagem
          </Typography>
        </Box>

        <TextField
          id="standard-corretagem"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={corretagem}
          disabled={readOnly}
          onChange={(e) =>
            //@ts-ignore
            setPropriedadeNota("corretagem", e.target.floatValue)
          }
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            ISS (Impostos)
          </Typography>
        </Box>

        <TextField
          id="standard-iss"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={iss}
          disabled={readOnly}
          //@ts-ignore
          onChange={(e) => setPropriedadeNota("iss", e.target.floatValue)}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            I.R.R.F.
          </Typography>
        </Box>

        <TextField
          id="standard-irrf"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={irrf}
          disabled={readOnly}
          onChange={(e) =>
            //@ts-ignore
            setPropriedadeNota("irrf", e.target.floatValue)
          }
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        paddingTop={1}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.secondary">
            Outros(as) (Bovespa)
          </Typography>
        </Box>

        <TextField
          id="standard-outrosCustos"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          value={outrosCustos}
          disabled={readOnly}
          onChange={(e) =>
            //@ts-ignore
            setPropriedadeNota("outrosCustos", e.target.floatValue)
          }
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
      {/* Total: separado por hairline e com o número em mono peso 500. */}
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent={"space-between"}
        alignItems="center"
        borderTop={1}
        borderColor="divider"
        marginTop={1.5}
        paddingTop={1.5}
      >
        <Box flexBasis="75%" paddingRight={1}>
          <Typography variant="labelMono" color="text.primary">
            Total Custos / Despesas
          </Typography>
        </Box>

        <TextField
          id="standard-totalDespesas"
          size="small"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          disabled
          value={totalCorretagem}
          sx={{ "& input": { fontWeight: 500 } }}
          InputProps={{
            inputComponent: MoedaInput,
          }}
        />
      </Box>
    </Box>
  );
}
